import { render, staticRenderFns } from "./IconFiscalNote.vue?vue&type=template&id=4f47f227&"
import script from "./IconFiscalNote.vue?vue&type=script&lang=ts&"
export * from "./IconFiscalNote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports